import { render, staticRenderFns } from "./PublicHijri.vue?vue&type=template&id=0f6e08ca&"
import script from "./PublicHijri.vue?vue&type=script&lang=js&"
export * from "./PublicHijri.vue?vue&type=script&lang=js&"
import style0 from "./PublicHijri.vue?vue&type=style&index=0&id=0f6e08ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports